export default __webpack_public_path__ + "static/media/johnlevengoodlogo.59174727.svg";